/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import twitter from '../../assets/icons/twitter1.png';
import './Spotlight3Details.scss';
import instagram from '../../assets/icons/instagram.png';
import logo from '../../assets/icons/layerrlogo.png';
import Spotlight3ConnectWallet from '../Spotlight3ConnectWallet';

function Spotlight3Details() {
  const [formattedDate, setFormattedDate] = useState(null);
  const [timeLeft, setTimeLeft] = useState(null);
  const startTime = (1676379600); // February 14th 8:00am EST.
  const endTime = (1676552400); // February 16th 8:00am EST.

  useEffect(() => {
    const intervalId = setInterval(() => {
      const now = new Date().getTime(); // Get current time in milliseconds.
      const diff = (startTime * 1000) - now;
      if (diff > 0) { // this means the mint has not started yet.
        setFormattedDate('Feb 14th 8:00am EST - Feb 16th 8:00am EST');
      } else if (diff === 0 || diff < 0) { // this means the mint has started.
        if (now > (endTime * 1000)) { // this means the mint has ended.
          clearInterval(intervalId);
          const ended = new Date(endTime * 1000).toLocaleString('en-US', {
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            hour12: true,
          });
          setFormattedDate(`Mint ended on ${ended}`);
          setTimeLeft(null);
        } else { // this means the mint is in progress.
          const newDifference = endTime * 1000 - now;
          setTimeLeft({
            days: Math.floor(newDifference / (1000 * 60 * 60 * 24)),
            hours: Math.floor((newDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
            minutes: Math.floor((newDifference % (1000 * 60 * 60)) / (1000 * 60)),
            seconds: Math.floor((newDifference % (1000 * 60)) / 1000),
          });
        }
      }
    }, 1000);
    return () => clearInterval(intervalId);
  }, [formattedDate]);

  return (
    <>
      <div className="sptlght3__connect-container">
        <h1>WE ARE CONNECTED</h1>
        <div className="sptlght3__connect-display-button sptlght3__connect-display-button--desktop">
          <Spotlight3ConnectWallet />
        </div>
      </div>
      <a href="https://twitter.com/Tylersjourney_" target="_blank" style={{ fontSize: '14px', color: 'white', fontWeight: '400', marginBottom: '0.5rem' }} rel="noreferrer">created by TylersJourney</a>
      <section>
        <div className="flex-row justify-between" style={{ height: 'fit-content' }}>
          <span className="sptlght3-details__project-description">
            Choose your own adventure or collect both &apos;Dystopia&apos; and &apos;Together&apos; to combine powers and receive a 3rd FREE NFT &apos;Equilibrium&apos;. YOU are the Main Character in this story.
            You must collect equal amounts of &apos;Dystopia&apos; and &apos;Together&apos; to receive &apos;Equilibrium&apos; in return.
          </span>
          <div className="sptlght3__social-icons-tablet">
            <a target="_blank" href="https://twitter.com/Tylersjourney_" type="button" rel="noreferrer"><img className="sptlght3__social-icon" src={twitter} alt="twitter icon" /></a>
            <a target="_blank" href="https://www.instagram.com/tylersjourney/" type="button" rel="noreferrer"><img className="sptlght3__social-icon sptlght3__social-icon--tablet" src={instagram} alt="instagram icon" /></a>
          </div>
        </div>
        <div className="sptlght3-details__main-content">
          <div className="sptlght3-details__main-content-container">
            <div className="sptlght3-details">
              <p className="sptlght3__sub-label">
                Contract Address:
                <a target="_blank" rel="noreferrer" href="https://etherscan.io/address/0x3360c2e7bc089196cc27bb4a388b4a70ebad8b7a"><span> 0x336...8B7A</span></a>
              </p>
              <p className="sptlght3__sub-label">
                Token standard:
                <span> ERC 1155</span>
              </p>
              <p className="sptlght3__sub-label">
                Blockhain:
                <span> Ethereum</span>
              </p>
              <p className="sptlght3__sub-label">
                Mint ended on:
                <span> Feb 16th, 8:00am EST</span>
              </p>
              {/* {timeLeft ? (
                <p className="atd1__details-label">Mint closes in:
                  <span className="atd1__details-value">{' '}
                    {`${timeLeft.days} d ${timeLeft.hours} h ${timeLeft.minutes} m ${timeLeft.seconds} s`}
                  </span>
                </p>
              ) : (
                <p className="sptlght3__sub-label">
                  Mint Date:
                  <span> {formattedDate}</span>
                </p>
              ) } */}
            </div>
            <div className="sptlght3__marketplaces">
              <p className="sptlght3__sub-label">View On Opensea</p>
              <a target="_blank" rel="noreferrer" href="https://opensea.io/assets/ethereum/0x3360c2e7bC089196cc27BB4a388b4A70ebaD8B7A/0" className="sptlght3__marketplace">
                <span>Together</span>
                <span>⟶</span>
              </a>
              <a target="_blank" rel="noreferrer" href="https://opensea.io/assets/ethereum/0x3360c2e7bC089196cc27BB4a388b4A70ebaD8B7A/1" className="sptlght3__marketplace">
                <span>Dystopia</span>
                <span>⟶</span>
              </a>
              <a target="_blank" rel="noreferrer" href="https://opensea.io/assets/ethereum/0x3360c2e7bC089196cc27BB4a388b4A70ebaD8B7A/2" className="sptlght3__marketplace">
                <span>Equilibrium</span>
                <span>⟶</span>
              </a>
            </div>
          </div>
          <div className="sptlght3__social-icons-mobile">
            <a href="https://twitter.com/Tylersjourney_" type="button"><img className="sptlght3__social-icon" src={twitter} alt="twitter icon" /></a>
            <a href="https://www.instagram.com/tylersjourney/" type="button"><img className="sptlght3__social-icon sptlght3__social-icon--mobile" src={instagram} alt="instagram icon" /></a>
          </div>
        </div>
        <div className="sptlght3__layerr">
          Crafted with
          {' '}
          <a target="_blank" rel="noreferrer" href="https://layerr.art"><img className="sptlght3__layerr-logo" src={logo} alt="layerr logo" /></a>
        </div>
      </section>
    </>
  );
}

export default Spotlight3Details;
